type Json = any;

export async function apiFetch(path: string, opts: RequestInit & { tenantLabel?: string } = {}): Promise<Response> {
  const headers = new Headers(opts.headers || {});
  headers.set("X-Tenant-ID", opts.tenantLabel || "root");
  if (opts.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const res = await fetch(path, { ...opts, headers });
  return res;
}

export async function apiJson<T = Json>(path: string, opts: RequestInit & { tenantLabel?: string } = {}): Promise<T> {
  const res = await apiFetch(path, opts);
  const text = await res.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    const msg = typeof data === "string" ? data : JSON.stringify(data);
    throw new Error(`HTTP ${res.status}: ${msg}`);
  }
  return data as T;
}
